import { put, call, takeEvery, takeLatest } from "redux-saga/effects";
import * as apis from "../../network/apis/products";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";

function* reviewRequestsListSaga({ payload }) {
  try {
    const response = yield call(apis.reviewRequestsList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.reviewRequestsListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.reviewRequestsListRequest({
          ...payload,
          page: +response.headers["total-pages"]
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* approvedProductsListSaga({ payload }) {
  try {
    const response = yield call(apis.approvedProductsList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.approvedProductsListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.approvedProductsListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* approveProductRequestSaga({ payload }) {
  try {
    const { id, navigate } = payload;
    yield call(apis.approveProductRequest, id);
    yield showSuccessMsg("productApproved");
    navigate(ROUTE_PATHS.productDetailsApproved.replace(":id", id));
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* rejectProductRequestSaga({ payload }) {
  try {
    const { data, navigate } = payload;
    yield call(apis.rejectProductRequest, data);
    yield showSuccessMsg("productRejected");
    navigate(
      ROUTE_PATHS.productDetailsApproved.replace(":id", data.Id)
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* productDetailsSaga({ payload }) {
  try {
    const response = yield call(apis.getProductDetails, payload);
    yield put(actions.productDetailsResponse(response.data.Data));
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* productVersionDetailsSaga({ payload }) {
  try {
    const response = yield call(
      apis.getProductVersionDetails,
      payload
    );
    yield put(
      actions.productVersionDetailsResponse(response.data.Data)
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

export default function* ProductsSagas() {
  yield takeLatest(
    types.REVIEW_REQUESTS_LIST_REQUEST,
    reviewRequestsListSaga
  );
  yield takeLatest(
    types.APPROVED_PRODUCTS_LIST_REQUEST,
    approvedProductsListSaga
  );
  yield takeEvery(
    types.APPROVE_PRODUCT_REQUEST,
    approveProductRequestSaga
  );
  yield takeEvery(
    types.REJECT_PRODUCT_REQUEST,
    rejectProductRequestSaga
  );
  yield takeEvery(types.PRODUCT_DETAILS_REQUEST, productDetailsSaga);
  yield takeEvery(
    types.PRODUCT_VERSION_DETAILS_REQUEST,
    productVersionDetailsSaga
  );
}
